import usePropsContext from '/druid/internal/usePropsContext';

export default function useStyleOptions() {
  const { styleOptions } = usePropsContext();

  return [styleOptions];
}
